<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav :menuItems="menuItems" class="side-nav"></side-nav>

      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';
import {IS_DEV} from '../../autogen/version.js';

export default {
  name: 'RiverRumble',

  components: {
    MyHeader,
    SideNav,
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'River rumbles',
          route: {name: 'river_rumble_timetable'},
          exact: true,
        },
        {
          title: 'Average fails',
          route: {name: 'river_rumble_average_fails'},
          exact: true,
        },
      ];

      if (IS_DEV) {
        items.push(
            {
              title: 'Generate players',
              route: {name: 'river_rumble_generate_players'},
              exact: true,
            },
            {
              title: 'Generate stats',
              route: {name: 'river_rumble_generate_stats'},
              exact: true,
            },
            {
              title: 'Test random players',
              route: {name: 'river_rumble_test_random_players'},
              exact: true,
            },
            {
              title: 'Test simulate join',
              route: {name: 'river_rumble_test_simulate_join'},
              exact: true,
            }
        );
      }

      return items;
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 1em;
}
</style>
